import { axiosIns } from "../utils";

const isFormDataPayload = (payload) =>
  typeof FormData !== "undefined" && payload instanceof FormData;

export const fetchRecruitments = async () => {
  const res = await axiosIns.get("/recruitments/");
  return res && res.data ? res.data : res;
};

export const fetchRecruitmentById = async (id) => {
  const res = await axiosIns.get(`/recruitments/${id}/`);
  return res && res.data ? res.data : res;
};

export const createRecruitmentApi = async (payload) => {
  const config = isFormDataPayload(payload)
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined;
  const res = await axiosIns.post("/recruitments/", payload, config);
  return res && res.data ? res.data : res;
};

export const updateRecruitmentApi = async (id, payload) => {
  const config = isFormDataPayload(payload)
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined;
  const res = await axiosIns.patch(`/recruitments/${id}/`, payload, config);
  return res && res.data ? res.data : res;
};

export const deleteRecruitmentApi = async (id) => {
  const res = await axiosIns.delete(`/recruitments/${id}/`);
  return res && res.data ? res.data : res;
};

export const publishRecruitmentApi = async (id) => {
  const res = await axiosIns.patch(`/recruitments/${id}/publish/`);
  return res && res.data ? res.data : res;
};
